<template>
  <div>
    <template v-if="field.name === 'quantity'">
      <b-form-group label="Quantity:" label-for="quantity">
        <b-form-select id="quantity" :value="value" @input="updateData($event)">
          <option v-for="i in this.selectedItem.campaign_product.max_quantity" :key="i" :value="i">{{i}}</option>
        </b-form-select>
      </b-form-group>
    </template>
    <template v-else-if="field.name === 'next_bill_date'">
      <b-form-group :label="nextBillDateLabel" label-for="next_bill_date">
        <b-modal
          id="next_bill_date"
          centered
          hide-footer
          hide-header
          size="md"
        >
          <datepicker
            :value="value"
            format="M/d/yyyy"
            :disabled-dates="{to: beforeStartDate, from: afterEndDate}"
            :bootstrap-styling="true"
            :inline="true"
            maximum-view="day"
            @selected="selectDate"
          ></datepicker>
          <b-link block class="centered-block close-button" variant="secondary" @click="hideCalendar()">&times;</b-link>
        </b-modal>
        <div class="datepicker-field">
          <b-form-input
            type="text"
            :value="dateString"
            :readonly="true"
            @click="showCalendar()"
          ></b-form-input>
          <div class="calendar-icon" @click="showCalendar()">
            <font-awesome-icon :icon="['far', 'calendar-alt']"></font-awesome-icon>
          </div>
        </div>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { FulfillmentType } from '../constants'

export default {
  name: 'InputField',
  components: {
    Datepicker
  },
  props: {
    session: Object,
    field: Object,
    default: [String, Number],
    item: Object,
    input: Object
  },
  data: function() {
    return {
      value: null,
      selectedItem: null
    }
  },
  computed: {
    beforeStartDate: function() {
      let dt = new Date()

      if (this.field.min) {
        dt = new Date(this.field.min)
      } else {
        const current = new Date(this.value)
        const today = dt.getDate()
        dt.setDate((current.getDate() > today) ? today + 1 : today)
      }

      dt.setHours(0)
      dt.setMinutes(0)
      dt.setSeconds(0)

      return dt
    },
    afterEndDate: function() {
      let dt = new Date()

      if (this.field.max) {
        dt = new Date(this.field.max)
        dt.setDate(dt.getDate() + 1)
      } else {
        dt.setMonth(dt.getMonth() + 1)
      }

      dt.setHours(0)
      dt.setMinutes(0)
      dt.setSeconds(0)

      return dt
    },
    dateString: function() {
      if (this.value) {
        let dt = new Date(this.value)
        return dt.toLocaleDateString()
      }

      return 'Please select a date'
    },
    nextBillDateLabel: function() {
      return (this.selectedItem && this.selectedItem.product.fulfillment_type === FulfillmentType.NoShipping)
        ? 'Next Scheduled Bill Date:' : 'Next Scheduled Ship Date:'
    }
  },
  methods: {
    showCalendar: function() {
      this.$bvModal.show('next_bill_date')
    },
    hideCalendar: function() {
      this.$bvModal.hide('next_bill_date')
    },
    updateData: function(val) {
      this.value = val
      this.$parent.updateData(this.field.name, val)
    },
    selectDate: function(date) {
      this.updateData(date.toISOString())
      this.hideCalendar()
    }
  },
  created: function() {
    this.selectedItem = this.item || this.session.selected_item
    this.value = this.default
  }
}
</script>

<style scoped lang="less">
  #next_bill_date {
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #eaefe5;
  }
</style>
